import apiClient from '../lib/apiClient';

const companyService = {
  // Get company information
  getCompanyInfo: async () => {
    try {
      const result = await apiClient.get('/company');
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch company information' };
    }
  },

  // Update company information
  updateCompanyInfo: async (data) => {
    try {
      const result = await apiClient.put('/company', data);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to update company information' };
    }
  },

  // Upload company logo
  uploadLogo: async (file) => {
    try {
      const token = localStorage.getItem('erp_auth_token');
      const formData = new FormData();
      formData.append('logo', file);

      const response = await fetch(`${import.meta.env.VITE_API_BASE_URL || `http://${window.location.hostname}:8000/api`}/company/uploadLogo`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          // Don't set Content-Type header - browser will set it with boundary for FormData
        },
        body: formData,
      });

      // Check if response is JSON
      const contentType = response.headers.get('content-type');
      let data;

      if (contentType && contentType.includes('application/json')) {
        data = await response.json();
      } else {
        // If not JSON, read as text to see what we got
        const text = await response.text();
        console.error('Non-JSON response:', text);
        return {
          success: false,
          error: `Server returned non-JSON response. Status: ${response.status}`
        };
      }

      if (!response.ok) {
        return { success: false, error: data.error || data.message || 'Failed to upload logo' };
      }

      return { success: true, data: data.data };
    } catch (error) {
      console.error('Upload logo error:', error);
      if (error.message.includes('JSON')) {
        return { success: false, error: 'Server response error. Please check server logs.' };
      }
      return { success: false, error: error.message || 'Failed to upload logo' };
    }
  }
};

export default companyService;

